import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ConnectedPosition } from '@angular/cdk/overlay';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { ChatSessionService } from '../../services/chat-session.service';
import { CHAT_BOT_ROUTE } from '../../chat-bot.component';
import { StylingColoursService } from '@app/modules/site-settings-styling/components/styling-colours/services/styling-colours.service';

@Component({
  selector: 'app-chat-launcher',
  templateUrl: './chat-launcher.component.html',
  styleUrls: ['./chat-launcher.component.scss']
})
export class ChatLauncherComponent implements OnInit {
  session = inject(ChatSessionService);
  private router = inject(Router);
  private destroyRef = inject(DestroyRef);
  private stylingColoursService = inject(StylingColoursService);

  isOpen = false;
  onChatPage = false;

  readonly positions: ConnectedPosition[] = [
    { originX: 'end', originY: 'bottom', overlayX: 'end', overlayY: 'top', offsetY: 10 },
    { originX: 'center', originY: 'bottom', overlayX: 'center', overlayY: 'top', offsetY: 10 }
  ];

  get accent() {
    return this.stylingColoursService.activeStylingColour?.primaryColour || '#ff9e18';
  }

  ngOnInit() {
    this.updateRoute(this.router.url);
    this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd), takeUntilDestroyed(this.destroyRef))
      .subscribe((e) => this.updateRoute(e.urlAfterRedirects));
  }

  toggle() {
    this.isOpen ? this.close() : this.open();
  }

  open() {
    this.isOpen = true;
    this.session.unread.set(false);
  }

  close() {
    this.isOpen = false;
    this.session.unread.set(false);
  }

  private updateRoute(url: string) {
    this.onChatPage = url.split('?')[0].toLowerCase() === CHAT_BOT_ROUTE.toLowerCase();
    if (this.onChatPage) this.isOpen = false;
  }
}
